<template>
  <el-upload
      ref="uploadRef"
      :class="uploadClass"
      :action="action"
      :headers="headers"
      :file-list="fileList"
      :accept="accept"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      list-type="picture-card"
      :on-remove="handleRemove">
    <i class="el-icon-plus"></i>
  </el-upload>
</template>

<script>
export default {
  name: "PictureUpload",
  props: {
    value: {
      type: String,
      default: () => "",
    },
    accept: {
      type: String,
      default: () => ".png,.jpg,.jpeg",
    },
    limit: {
      type: Number,
      default: () => 1,
    }
  },
  data() {
    return {
      action: `${process.env.VUE_APP_APIURL}guide/upload`,
      headers: {
        authorization: this.$store.state.token,
      },
      fileList: [],
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    uploadClass() {
      let str = "";
      if (this.modelValue) {
        str = "not-upload"
      }
      return str;
    },
  },
  created() {

  },
  mounted() {

  },
  beforeDestroy() {
    this.$refs.uploadRef.clearFiles();
  },
  methods: {
    setImage() {
      this.$nextTick(() => {
        this.fileList = [
          {
            name: "image.png",
            url: this.modelValue,
            response: {
              data: this.modelValue,
            }
          }
        ]
      })
    },
    beforeUpload(file) {
      let extension = `.${file.name.split(".")[1]}`,
          extensionList = this.accept.split(",");
      if (!extensionList.includes(extension)) {
        this.$message.error("文件格式不正确！");
        return false;
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleSuccess(res, file, fileList) {
      const { data } = res;
      this.modelValue = data;
    },
    // eslint-disable-next-line no-unused-vars
    handleError(err, file, fileList) {
      const { message } = JSON.parse(err.message);
      this.$message.error(message);
    },
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList) {
      if (file.response) {
        // const { data } = file.response;
        this.modelValue = "";
      }
    },
  },
}
</script>


<style scoped lang="scss">
.not-upload{
  :deep(.el-upload) {
    display: none;
  }
}
</style>
